export const ar = {
  auth: {
    emailPasswordRequired: "يرجى إدخال بريدك الإلكتروني وكلمة المرور.",
    rateLimited: "محاولات تسجيل دخول فاشلة كثيرة جدًا. حاول مرة أخرى لاحقًا.",
    invalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
    unexpectedError: "حدث خطأ غير متوقع. حاول مرة أخرى.",
  },
  password: {
    doesNotMatch: "كلمتا المرور غير متطابقتين",
    doesNotMeetRequirements: "كلمة المرور لا تستوفي جميع المتطلبات",
    tooShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
  },
} as const;
